import React from 'react';
import { AnnouncementCard } from '../components/AnnouncementCard';
import { PDFDownloadCard } from '../components/PDFDownloadCard';
import { AlertCircle, FileText, Download } from 'lucide-react';
import { SEO } from '../components/SEO';
export function KeterbukaanInformasiPage() {
  return <>
      <SEO title="Keterbukaan Informasi - PT Wahana Konstruksi Mandiri | Transparansi & Compliance" description="Pusat keterbukaan informasi PT WKM: Pengumuman material, laporan keuangan, dokumen perusahaan, informasi MTO & akuisisi. Komitmen pada transparansi dan kepatuhan regulator." keywords="keterbukaan informasi, transparansi perusahaan, laporan keuangan, pengumuman material, MTO, akuisisi, compliance, corporate disclosure, investor relations" data-id="element-334" />

      <div className="py-12 bg-wkm-slate-50 min-h-screen" data-id="element-335">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-336">
          <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-12 rounded-r-lg" data-id="element-337">
            <div className="flex items-start" data-id="element-338">
              <AlertCircle className="w-6 h-6 text-red-600 mr-4 flex-shrink-0 mt-0.5" data-id="element-339" />
              <div data-id="element-340">
                <h2 className="text-xl font-bold text-red-900 mb-2" data-id="element-341">
                  Pusat Keterbukaan Informasi
                </h2>
                <p className="text-red-800 mb-4" data-id="element-342">
                  Halaman ini menyediakan akses terhadap informasi material dan
                  dokumen penting perusahaan sebagai bentuk kepatuhan terhadap
                  regulasi dan transparansi kepada publik.
                </p>
                <p className="text-sm text-red-700" data-id="element-343">
                  Untuk pertanyaan lebih lanjut, hubungi Corporate Secretary:{' '}
                  <a href="mailto:corsec@wkmkonstruksi.id" className="font-semibold underline" data-id="element-344">
                    corsec@wkmkonstruksi.id
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className="mb-12" data-id="element-345">
            <div className="flex items-center mb-6" data-id="element-346">
              <FileText className="w-6 h-6 text-wkm-gold-600 mr-3" data-id="element-347" />
              <h2 className="text-2xl font-bold text-wkm-navy-900" data-id="element-348">
                Pengumuman Material
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-349">
              <AnnouncementCard date="2024-12-15" title="Update Proses Mandatory Tender Offer (MTO)" category="Material Information" description="Perkembangan terkini mengenai proses Mandatory Tender Offer sesuai ketentuan OJK." data-id="element-350" />
              <AnnouncementCard date="2024-12-10" title="Informasi Akuisisi Saham" category="Corporate Action" description="Pengumuman resmi terkait rencana akuisisi dan struktur kepemilikan perusahaan." data-id="element-351" />
              <AnnouncementCard date="2024-11-25" title="Laporan Kinerja Q3 2024" category="Financial Report" description="Ringkasan kinerja keuangan dan operasional kuartal ketiga tahun 2024." data-id="element-352" />
              <AnnouncementCard date="2024-11-15" title="Keterbukaan Informasi Transaksi Material" category="Material Transaction" description="Informasi mengenai transaksi material yang memerlukan persetujuan RUPS." data-id="element-353" />
            </div>
          </div>

          <div className="mb-12" data-id="element-354">
            <div className="flex items-center mb-6" data-id="element-355">
              <Download className="w-6 h-6 text-wkm-gold-600 mr-3" data-id="element-356" />
              <h2 className="text-2xl font-bold text-wkm-navy-900" data-id="element-357">
                Dokumen Perusahaan
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-358">
              <PDFDownloadCard title="Company Profile 2024" description="Profil lengkap perusahaan termasuk visi, misi, dan layanan." fileSize="5.2 MB" downloadUrl="https://drive.google.com/file/d/1uTnFz_7YzLi1HhnoG9POlSh5stVvcW9A/view?usp=sharing" data-id="element-359" />
              <PDFDownloadCard title="Laporan Tahunan 2023" description="Annual report lengkap tahun fiskal 2023." fileSize="8.5 MB" downloadUrl="#" data-id="element-360" />
              <PDFDownloadCard title="Laporan Keuangan Q3 2024" description="Laporan keuangan kuartal ketiga 2024 (unaudited)." fileSize="2.1 MB" downloadUrl="#" data-id="element-361" />
              <PDFDownloadCard title="Anggaran Dasar Perusahaan" description="Anggaran Dasar dan perubahannya." fileSize="1.8 MB" downloadUrl="#" data-id="element-362" />
              <PDFDownloadCard title="Struktur Organisasi" description="Bagan struktur organisasi dan manajemen." fileSize="0.9 MB" downloadUrl="#" data-id="element-363" />
              <PDFDownloadCard title="Sertifikasi ISO" description="Sertifikat ISO 9001, 14001, 45001, 37001." fileSize="3.2 MB" downloadUrl="#" data-id="element-364" />
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 border border-wkm-slate-200" data-id="element-365">
            <h2 className="text-2xl font-bold text-wkm-navy-900 mb-6" data-id="element-366">
              Informasi Kontak
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-367">
              <div data-id="element-368">
                <h3 className="text-lg font-bold text-wkm-navy-900 mb-3" data-id="element-369">
                  Corporate Secretary
                </h3>
                <p className="text-wkm-slate-600 mb-4" data-id="element-370">
                  Untuk pertanyaan terkait keterbukaan informasi, investor
                  relations, dan komunikasi dengan regulator.
                </p>
                <p className="text-wkm-slate-700" data-id="element-371">
                  Email:{' '}
                  <a href="mailto:corsec@wkmkonstruksi.id" className="text-wkm-gold-600 hover:text-wkm-gold-700 font-semibold" data-id="element-372">
                    corsec@wkmkonstruksi.id
                  </a>
                </p>
              </div>
              <div data-id="element-373">
                <h3 className="text-lg font-bold text-wkm-navy-900 mb-3" data-id="element-374">
                  Kantor Pusat
                </h3>
                <p className="text-wkm-slate-600 mb-4" data-id="element-375">
                  Jl. Kodeco KM 2 Ruko Jhonlin Indah Blok B No. 09, Tanah Bumbu,
                  Kalimantan Selatan 72213
                </p>
                <p className="text-wkm-slate-700" data-id="element-376">
                  Telp:{' '}
                  <a href="tel:02155531569" className="text-wkm-gold-600 hover:text-wkm-gold-700 font-semibold" data-id="element-377">
                    (021) 5553 1569
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
}